import { useInfiniteQuery, UseInfiniteQueryResult, useMutation, useQueryClient } from 'react-query';
import { APIErrorType } from '../../api';
import {
  fetchStudentQuestions,
  StudentQuestionOverviewType,
  StudentQuestionType,
  updateStudentQuestionOption,
  updateStudentQuestionOptionDataType
} from '../../api/student-question';
import { PagintionType } from '../../utils';

export type useStudentQuestionsInfiniteQueryReturnType<
  SQT extends StudentQuestionOverviewType | StudentQuestionType
> = UseInfiniteQueryResult<PagintionType<SQT>>;

export function useStudentQuestionsInfiniteQuery<
  SQT extends StudentQuestionOverviewType | StudentQuestionType
>(examId: number | undefined): useStudentQuestionsInfiniteQueryReturnType<SQT> {
  if (!examId) throw Error('examId is undefiend');
  return useInfiniteQuery<
    PagintionType<SQT>,
    APIErrorType,
    PagintionType<SQT>,
    [string, { examId: number }]
  >(['student-questions', { examId }], fetchStudentQuestions, {
    getNextPageParam: lastPage => (lastPage.nextPage ? lastPage.nextPage : undefined),
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false
  });
}

export function useUpdateStudentQuestionOptionMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    StudentQuestionOverviewType,
    APIErrorType,
    updateStudentQuestionOptionDataType
  >(updateStudentQuestionOption, {
    onSuccess: async studentQuestion => {
      const queryKey = ['student-questions', { examId: studentQuestion.exam }];
      const data: { pages: PagintionType<StudentQuestionOverviewType>[] } | undefined =
        await queryClient.getQueryData(queryKey);
      queryClient.setQueryData(queryKey, {
        ...data,
        pages: data?.pages.map(page => ({
          ...page,
          data: page.data.map(sq => (studentQuestion.id === sq.id ? studentQuestion : sq))
        }))
      });
    }
  });
}
